import { useUIStore } from '@/state/uiStore';

const COLOR = { info: '#4cd1ff', warn: '#ffd166', error: '#ef5350' };

export function Toast() {
  const t = useUIStore((s) => s.toast);
  if (!t) return null;
  return (
    <div style={{
      position: 'absolute', top: 70, left: '50%', transform: 'translateX(-50%)',
      padding: '8px 14px', borderRadius: 6,
      background: 'rgba(11,13,18,0.95)', color: COLOR[t.level], border: `1px solid ${COLOR[t.level]}`,
      fontSize: 14, zIndex: 1000,
    }}>
      {t.text}
    </div>
  );
}
